import { render, staticRenderFns } from "./ProductoDetalle.vue?vue&type=template&id=a56eb8b0&scoped=true"
import script from "./ProductoDetalle.vue?vue&type=script&lang=js"
export * from "./ProductoDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProductoDetalle.vue?vue&type=style&index=0&id=a56eb8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56eb8b0",
  null
  
)

export default component.exports